export default __webpack_public_path__ + "static/diana_macau-1710cfc601bfc8240233d7fb84d5253b.jpg";